import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-durham-navbar',
  templateUrl: './durham-navbar.component.html',
  styleUrls: ['./durham-navbar.component.scss']
})
export class DurhamNavbarComponent implements OnInit {
  faTimes = faTimes;
  public isMenuCollapsed = true;

  public visible = true;

  constructor(public router:Router, public activeRouter: ActivatedRoute) { }

  ngOnInit(): void {
  }
  navFunction(){
    this.visible = !this.visible; 
  }
}
